/**
 * Global Search API Endpoints
 * Handles searching across Adventures, Users, and Groups
 */

import { ApiService } from '../apiService'
import type {
  AdventureQuickStatsResponse,
  GlobalSearchRequest,
  GlobalSearchResponse,
  UserSearchResult,
} from '../types/search'

export const searchApi = {
  /**
   * Global search across all entity types (Adventures, Users, Groups)
   * @param request - Search parameters including query, filters, location, and pagination
   * @returns Search results grouped by entity type
   */
  search: (request: GlobalSearchRequest) =>
    ApiService.post<GlobalSearchResponse>('/api/search', request),

  /**
   * Quick search for specific entity type
   * @param query - Search term
   * @param type - Entity type ('users', 'groups', 'adventures')
   * @param take - Number of results to return
   */
  quickSearch: (query: string, type: string, take: number = 10) =>
    ApiService.get<UserSearchResult[]>('/api/search/quick', { query, type, take }),

  /**
   * Get quick stats for an adventure's popularity
   * @param adventureId - The adventure ID to get stats for
   * @returns Unique player counts over various time periods
   */
  getAdventureQuickStats: (adventureId: string) =>
    ApiService.get<AdventureQuickStatsResponse>(`/api/search/quick-stats`, { adventureId }),
}
